import React from 'react';
import { FiMail, FiChevronDown } from 'react-icons/fi';
import { FaLinkedinIn, FaYoutube, FaGithub } from 'react-icons/fa';
import styles from './Hero.module.css';
import { useLanguage } from '../../context/LanguageContext';

const Hero: React.FC = () => {
  const { t } = useLanguage();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className={styles.hero} id="hero">
      <div className={styles.meshBg} />
      <div className={styles.inner}>
        <div className={styles.badge}>
          <span className={styles.dot} />
          Amsterdam, Netherlands
        </div>

        <p className={styles.greeting}>{t.hero.greeting}</p>
        <h1 className={styles.name}>
          Nuri Can <span>Akturk</span>
        </h1>
        <p className={styles.title}>{t.hero.title}</p>
        <p className={styles.bio}>{t.hero.bio}</p>

        <div className={styles.actions}>
          <button className={styles.ctaBtn} onClick={() => scrollTo('experience')}>
            {t.hero.cta} →
          </button>
        </div>

        <div className={styles.socialLinks}>
          <span
            className={styles.socialLink}
            onClick={() => scrollTo('contact')}
            role="button"
            tabIndex={0}
          >
            <FiMail /> Contact
          </span>
          <a
            href="https://linkedin.com/in/nuricanakturk"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <FaLinkedinIn /> LinkedIn
          </a>
          <a
            href="https://github.com/nuricanakturk"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <FaGithub /> GitHub
          </a>
          <a
            href="https://youtube.com/@nuricanakturk"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <FaYoutube /> YouTube
          </a>
        </div>
      </div>

      <div className={styles.scrollHint}>
        <span>scroll</span>
        <FiChevronDown />
      </div>
    </section>
  );
};

export default Hero;
